import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const LOGO_BASE = `${process.env.PUBLIC_URL || ''}/sportsbook-logos`;

const LogoImg = styled.img`
  display: inline-block;
  height: ${(props) => props.$size || '1.15em'};
  width: auto;
  max-height: 1.5rem;
  object-fit: contain;
  vertical-align: middle;
`;

const Fallback = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => props.$size || '0.95em'};
  width: 1.25em;
  height: 1.25em;
  border-radius: 0.25rem;
  background: ${(props) => props.theme?.tertiaryBg || 'transparent'};
  color: ${(props) => props.theme?.primaryText || 'inherit'};
  border: 1px solid ${(props) => props.theme?.border || 'rgba(0,0,0,0.15)'};
  vertical-align: middle;
`;

/**
 * Renders sportsbook provider logo next to odds.
 *
 * Provider key must match the filename in `frontend/public/sportsbook-logos/` (e.g. `betmgm`, `draftkings`).
 */
function SportsbookLogo({ provider, size = '1.1em', ariaLabel = 'Sportsbook logo' }) {
  const [tryPng, setTryPng] = useState(false);
  const [logoError, setLogoError] = useState(false);

  const key = provider == null ? null : String(provider).trim().toLowerCase();

  useEffect(() => {
    setTryPng(false);
    setLogoError(false);
  }, [key]);

  if (!key || key === 'best') return null;

  const logoSrc = tryPng ? `${LOGO_BASE}/${key}.png` : `${LOGO_BASE}/${key}.svg`;

  const handleLogoError = () => {
    if (!tryPng) setTryPng(true);
    else setLogoError(true);
  };

  if (logoError) {
    const letter = key.charAt(0) || '?';
    return <Fallback $size={size} aria-label={ariaLabel}>{letter.toUpperCase()}</Fallback>;
  }

  return (
    <LogoImg
      $size={size}
      src={logoSrc}
      alt=""
      aria-label={ariaLabel}
      onError={handleLogoError}
    />
  );
}

export default SportsbookLogo;

